import  * as React from "react";
import { observer } from "mobx-react";
import { ISkidAndRollParameterNumberParams } from "./ISkidAndRollParameterNumberParams";

@observer
export class SkidAndRollParameterNumber extends React.Component<ISkidAndRollParameterNumberParams>{

    constructor(props: ISkidAndRollParameterNumberParams) {
        super(props, undefined);
    }
    render() {
        return <g className={"SkidAndRollParameterNumber " + this.props.className} transform={"translate(" + this.props.informationBoxX + "," + this.props.informationBoxY + ")"}>
            <text className="parameter-title" x={this.props.informationTitleX} y={this.props.informationTitleY} textAnchor={this.props.informationTitleTextAnchor}>{this.props.informationTitleText}</text>
                <text className="parameter-value" x={this.props.informationValueX} y={this.props.informationValueY} textAnchor={this.props.informationValueTextAnchor}>{this.props.informationValueText}</text>
            <text className="parameter-unit" x={this.props.informationUnitX} y={this.props.informationUnitY} textAnchor={this.props.informationUnitTextAnchor}>{this.props.informationUnitText}</text>
        </g>;
    }
}
